module.exports = __webpack_public_path__ + "static/media/lipstickExplore.aadfe7ca.png";